import React from 'react'
import {Helmet} from 'react-helmet-async'

import {usePageTitle} from '../../hooks/usePageTitle'

export const HelmetTitle: React.FC<{title?: string}> = ({title}) => {
  const pageTitle = usePageTitle(title)
  return <Helmet title={pageTitle} />
}
